export const AddressQcFieldName = 'addressQcFieldComponent';
